export default __webpack_public_path__ + "static/media/business-901.38ab663c.png";